var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "atom-spinner", style: _vm.spinnerStyle }, [
    _c("div", { staticClass: "spinner-inner" }, [
      _c("div", { staticClass: "spinner-line", style: _vm.lineStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "spinner-line", style: _vm.lineStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "spinner-line", style: _vm.lineStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "spinner-circle", style: _vm.circleStyle }, [
        _vm._v("\n      ●\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }